import type { FeatureFlagsConfig } from '../types';

/**
 * Default feature flags configuration
 * Used as fallback when database is unavailable
 * Matches the seeded values in the migration
 */
export const DEFAULT_FEATURE_FLAGS: FeatureFlagsConfig = {
  enableThemeToggle: true,
  enableAccountDeletion: true,
  enableTeamDeletion: true,
  enableTeamAccounts: false,
  enableTeamCreation: false,
  enablePersonalAccountBilling: false,
  enableTeamAccountBilling: false,
  languagePriority: 'user',
  enableNotifications: true,
  realtimeNotifications: true,
  enableVersionUpdater: true,
  enableSavedSignatures: true,
  enableCoaching: false,
  enableAmbassadors: false,
};
